import { ApolloClient } from '@apollo/client';

import { ArtistSearchResult, ArtistsSearchGateway } from '../types/Artists';
import {
  GeneratedGetArtistsBySlugQuery,
  GeneratedGetArtistsBySlugQueryVariables,
  GeneratedSearchArtistsQuery,
  GeneratedSearchArtistsQueryVariables,
  GetArtistsBySlugDocument,
  SearchArtistsDocument,
} from '../types/generated';

export class AvantArteArtistsSearchGateway implements ArtistsSearchGateway {
  constructor(private client: ApolloClient<any>) {}

  public async search(query: string): Promise<ArtistSearchResult[]> {
    const result = await this.client.query<
      GeneratedSearchArtistsQuery,
      GeneratedSearchArtistsQueryVariables
    >({
      query: SearchArtistsDocument,
      variables: {
        query,
      },
    });

    return result.data.searchArtists.map((artist) => ({
      id: artist.id,
      name: artist.name,
    }));
  }

  public async getArtistsBySlug(
    slugs: string[],
  ): Promise<ArtistSearchResult[]> {
    const result = await this.client.query<
      GeneratedGetArtistsBySlugQuery,
      GeneratedGetArtistsBySlugQueryVariables
    >({
      query: GetArtistsBySlugDocument,
      variables: {
        slugs,
      },
    });

    if (result.error || (result.errors && result.errors.length)) {
      return [];
    }

    return result.data.artistsBySlug.map((artist) => ({
      id: artist.id,
      name: artist.name,
      slug: artist.slug,
    }));
  }
}
